import { Link2, Loader2, Ticket } from 'lucide-react';
import { Button } from '@tark/shared/components';
import type { CompetitionPairInviteResponse } from '@tark/shared/lib';
import type { CompetitionHandoff } from '../../pages/competitions/competitionSecretHandoff';

export function CompetitionHandoffPanel({
  handoff,
  isAuthenticated,
  isAccountReady,
  pairPreview,
  isPreviewLoading,
  previewError,
  accountHref,
  onContinue,
}: {
  handoff: CompetitionHandoff;
  isAuthenticated: boolean;
  isAccountReady: boolean;
  pairPreview?: CompetitionPairInviteResponse;
  isPreviewLoading: boolean;
  previewError?: string | null;
  accountHref: string;
  onContinue: () => void;
}) {
  const isPair = handoff.kind === 'pair';
  const title = isPair ? 'Doubles invitation' : 'Registration ready to link';
  const description = isPair
    ? pairPreview
      ? `${pairPreview.inviterDisplayName} invited you to ${pairPreview.divisionName}.`
      : 'A TARK player shared a private fixed-pair invitation with you.'
    : 'An organizer prepared a registration for you. Link it to your verified TARK account.';

  return (
    <section className="mt-6 flex flex-col gap-4 rounded-lg border border-primary/25 bg-primary/5 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
      <div className="flex min-w-0 items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary text-white">
          {isPair ? <Link2 className="h-5 w-5" /> : <Ticket className="h-5 w-5" />}
        </span>
        <div className="min-w-0">
          <h2 className="font-bold text-text">{title}</h2>
          <p className="mt-1 text-sm text-text-muted">{description}</p>
          {previewError ? <p className="mt-2 text-sm font-medium text-red-600">{previewError}</p> : null}
        </div>
      </div>

      {isPreviewLoading ? (
        <span className="inline-flex shrink-0 items-center gap-2 text-sm font-semibold text-text-muted">
          <Loader2 className="h-4 w-4 animate-spin" />
          Checking invite
        </span>
      ) : !isAuthenticated || !isAccountReady ? (
        <Button type="button" onClick={() => { window.location.href = accountHref; }}>
          {!isAuthenticated ? 'Sign in to continue' : 'Finish account setup'}
        </Button>
      ) : (
        <Button type="button" onClick={onContinue} disabled={Boolean(previewError)}>
          {isPair ? 'Review invitation' : 'Review claim'}
        </Button>
      )}
    </section>
  );
}
